$(function() {
	var modals = {
		vars: {
			modal: null
		},

		init: function() {

			$('[href="#manifesto"]').magnificPopup({
				type: 'inline',
				src: '#manifesto',
				closeMarkup: '<button type="button" class="mfp-close">×</button>'
			});

			$('.slideshow').on('click', '.slideshow__link', function(e) {
				e.preventDefault();
			}).on('click', '.slideshow__slide', function() {
				var el = $(this);
				window.open(el.find('.slideshow__link').attr('href'), '_blank');
			});

			$('[video-modal]').on('click', function(e) {
				e.preventDefault();

				var el = $(this);
				$.magnificPopup.open({
					items: {
						src: el.attr('href')
					},
					mainClass: 'mfp-wrap--gallery',
					closeMarkup: '<button type="button" class="mfp-close">×</button>',
					type: 'iframe',
					iframe: {
						patterns: {
							youtube: {
								index: 'youtube.com/',
								id: 'v=',
								src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
							}
						}
					}
				}, 0);
			});

			//gallery
			$('.gallery__list').each(function() { // the containers for all your galleries
				$(this).magnificPopup({
					delegate: '.gallery-item__link[data-type=image]', // the selector for gallery item
					type: 'image',
					mainClass: 'mfp-wrap--gallery',
					gallery: {
						enabled: true
					},
					iframe: {
						patterns: {
							youtube: {
								index: 'youtube.com/',
								id: 'v=',
								src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
							}
						}
					}
				});
			});
		}
	}
	modals.init();
});